import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'audio-file-mp3';

const originalDimensions = {
    width: 29.8,
    height: 24,
};

export const IconAudioFileMP3 = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'tertiary-400';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses } = props;

    return (
        <svg
            aria-labelledby={iconId}
            className={cx(addClasses)}
            height={height}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Audio File MP3 Icon</title>
            <path
                d="M8.9 19.5v-7.4c0-.7.5-1.2 1.2-1.2h9.1V6.6c0-.5-.2-1-.6-1.4L12.9.4c-.4-.2-.8-.4-1.2-.4H2.2C0 0 0 .2 0 2.3v19.4C0 23.8 0 24 2.2 24H17c2.2 0 2.2-.2 2.2-2.3v-1h-9.1c-.6 0-1.2-.5-1.2-1.2zM6.5 11v.2c-.1.8-.9 1.4-1.9 1.4-1.1 0-1.9-.7-1.9-1.6 0-.9.9-1.6 1.9-1.6.2 0 .4 0 .6.1V5c0-.3.2-.6.5-.7l3.7-1.1c.5-.2.9.2.9.7V5c0 .4-.4.6-.6.7-.4 0-1.4.3-3.2.6V11z"
                opacity=".3"
                fill={fill}
            />
            <path
                d="M10.4 5V3.8c0-.5-.5-.9-.9-.7L5.7 4.2c-.3.1-.5.4-.5.8v4.5c-.2-.1-.4-.1-.6-.1-1.1 0-1.9.7-1.9 1.6 0 .9.9 1.6 1.9 1.6 1 0 1.8-.6 1.9-1.4V6.3c1.8-.3 2.8-.6 3.3-.7.2 0 .6-.3.6-.6z"
                fill={fill}
            />
            <path
                d="M29.8 17.2c0 1.2-.9 2.1-2.3 2.1-1.1 0-1.8-.4-2.4-1-.1-.1-.1-.2 0-.3l.7-.6c.1-.1.2-.1.3 0 .4.4.8.6 1.4.6.5 0 .9-.3.9-.8s-.5-.8-1.3-.8h-.6l-.2-.9 1.6-1.6h-2.3c-.1 0-.2-.1-.2-.2v-.8c0-.1.1-.2.2-.2h4.2v1c0 .1 0 .1-.1.2l-1.6 1.5c.9.1 1.7.6 1.7 1.8z"
                fill="#fff"
            />
            <path d="M17.3 12.7h-1.2c-.1 0-.2 0-.2.1l-1.6 2.6-1.6-2.6c0-.1-.1-.1-.2-.1h-1.2c-.1 0-.2.1-.2.2V19c0 .1.1.2.2.2h.9c.1 0 .2-.1.2-.2v-4l1.8 2.8L16 15v4c0 .1.1.2.2.2h1c.1 0 .2-.1.2-.2v-6.1c.2-.1.1-.2-.1-.2zM19.4 19.2h1c.1 0 .2-.1.2-.2v-1.7h1.1c1.5 0 2.6-.8 2.6-2.3 0-1.3-.9-2.3-2.5-2.3h-2.4c-.1 0-.1 0-.2.1v6.4h.2zm1.2-5.2h1.1c.7 0 1.2.3 1.2 1 0 .6-.4 1-1.1 1h-1.1v-2zM19.1 19c0 .1 0 .1.1.2v-6.4s-.1.1-.1.2v6zM28.1 15.3l1.6-1.5s.1-.1.1-.2v-1h-4.2c-.1 0-.2.1-.2.2v.8c0 .1.1.2.2.2h2.3l-1.6 1.6.2.9h.6c.8 0 1.3.3 1.3.8s-.4.8-.9.8c-.6 0-1-.2-1.4-.6-.1-.1-.2-.1-.3 0l-.7.7c-.1.1-.1.2 0 .3.6.6 1.3 1 2.4 1 1.5 0 2.3-.9 2.3-2.1 0-1.2-.8-1.7-1.7-1.9z" />
        </svg>
    );
};
